import React, { useEffect, useState } from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import { Dropdown as AntDropdown, Modal as AntDModal } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperclip, faTags, faTimes } from '@fortawesome/free-solid-svg-icons';
import { MultiSelectInpute } from './MultiSelectInpute/MultiSelectInput';
import JoditTextEditor from '../../common/JoditEditor/JoditTextEditor';
import swal from 'sweetalert';
import dayjs from 'dayjs';
import { faFile, faFileExcel, faFileImage, faFilePdf, faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import PreviewAndDownload from './PreviewAndDownload';
import Select from 'react-dropdown-select';
import { label, option } from 'react-dom-factories';

const ComposeEmail = ({
    isReply,
    isForward,
    emailContent,
    clickedFromBody,
    fromtask,
    task,
    handleSendButton,
    setOpenAssociatePopUp,
    attachments,
    allUsers,
    clearFields,
    handleNotificationHyperlink,
    draftId,
    selectedFolder,
    currentAccounts,
    signature,
    isSchedule,
    draftEmailContent,
    setIsSchedule,
    composeMailObj,
    isDraftAlready,
    setIsDraftAlready,
    userinfo,
    items,
    getCCOptions,
    viewEmail,
    contentShowFlag,
    setEmailContent,
    composeMailToShow,
    openSchedulePopup,
    setOpenSchedulePopup,
    setViewEmail,
    setReplyEmail,
    setContentShowFlag,
    setShowCC,
    showCC,
    showBCC,
    setShowBCC,
    setAttachments, 
    setComposeEmailPopUp,
    setComposeMailObj,
    handleSaveDraft,
    handleUploadFiles,
    handleSendEmail,
    UploadAttachments,
    DeleteDraftMsg,
    handleFileAttachments   
}) => { 
  const [openAttachmentPopUp,setOpenAttachmentPopUp]=useState(false); 
  const getIconByType=(name)=>{
      if(name.includes("pdf")){
        return <FontAwesomeIcon color='#007bff' icon={faFilePdf} />
      }else if(name.includes("xlx")){
        return <FontAwesomeIcon icon={faFileExcel} />
      }else if(name.includes("png") || name.includes("jpeg")){
        return <FontAwesomeIcon color='#007bff' icon={faFileImage} />
      }else{
        return <FontAwesomeIcon color='#007bff' icon={faFile} />
      }
    }  
    
  const AttachmentPopUp = () => {
    return <AntDModal 
    title="Attachments" 
    className='Attachment-PopUp'
    open={openAttachmentPopUp}
    onOk={e=>setOpenAttachmentPopUp(!openAttachmentPopUp)}
    onCancel={e=>setOpenAttachmentPopUp(!openAttachmentPopUp)}
    >
    {attachments?.map(att=>{
      return (<>
      <Row sm={12}>
        <Col sm={2}>{getIconByType(att?.attachmentName)}</Col>
        <Col sm={8}>{att?.attachmentName}</Col>
        <Col sm={2} className='Attach-Delete-Icon'><FontAwesomeIcon onClick={e=>{
          let arr=attachments.filter(a=>a.attachmentId!=att.attachmentId);
          setAttachments(arr);
          if(arr.length == 0){
            setOpenAttachmentPopUp(false)
          }
        }} icon={faTrashAlt}/></Col>
      </Row>
      </>) 
    })}
  </AntDModal>
  }
  console.log("structure of the dropdown",userinfo.email_id,task,[
    {label:userinfo.email_id==task?.TaskFlowObject?.BotAccountEmail?`${task?.TaskFlowObject?.BotAccountEmail} - Bot`:task?.TaskFlowObject?.BotAccountEmail,
    value:userinfo.email_id==task?.TaskFlowObject?.BotAccountEmail?`${task?.TaskFlowObject?.BotAccountEmail} - Bot`:task?.TaskFlowObject?.BotAccountEmail},
    {label:userinfo.email_id,value:userinfo.email_id}]);
  
  return (
    <Col sm={12} className="Compose-Email-Wrapper">
      {AttachmentPopUp()}
      <Row sm={12}>
        <Col sm={11} className="email-buttons">
          <AntDropdown.Button
            menu={{ items }}
            overlayClassName='sendLaterOption'
            className="compose-btns"
            trigger={"click"}
            icon={<DownOutlined />}
            onClick={() => handleSendButton(emailContent, isReply)}
          >
            Send
          </AntDropdown.Button>

          {!clickedFromBody && (
            <>
              {!fromtask &&<Button onClick={() => {
                handleSaveDraft(emailContent);
                setEmailContent("");
              }} className="compose-btns">
                Save Draft
              </Button>}
              
              <Button title='Upload attachments' onClick={handleUploadFiles} className="compose-btns" style={{ position: "relative" }}>
                <FontAwesomeIcon icon={faPaperclip} />
              </Button>

              {!fromtask && contentShowFlag!="compose" &&<Button onClick={() => {
                setOpenAssociatePopUp({
                  status: true,
                  possibleAssociationFlag: false,
                  email: null,
                  context: false
                });
              }} className="compose-btns">
                <FontAwesomeIcon icon={faTags} />
              </Button>}
            </>
          )}

         {!fromtask&&<Button onClick={() => {
            setContentShowFlag(""); 
            setEmailContent("");
            setViewEmail(null);
            setReplyEmail(false);
            setShowCC(false);
            setShowBCC(false);
          }} className="compose-btns">
            Cancel
          </Button>}

          {attachments && attachments.length > 0 && (
            <span onClick={() => setOpenAttachmentPopUp(!openAttachmentPopUp)} className="Attachmnets-Btn">
              Attachments ({attachments.length})
            </span>
          )} 
                         </Col>
        {!fromtask && <Col sm={1} className="mb-2 mt-1 right">
          <button onClick={() => {
            swal({
              title: "Save this email as Draft?",
              icon: "warning",
              buttons: ["Discard", "Save Draft"],
              dangerMode: true,
            }).then(async (save) => {
              if (save) {
                const obj = { ...composeMailObj };
                await UploadAttachments(attachments).then(res => {
                  if (res.length > 0) {
                    obj["attachments"] = res.map(k => { delete k.url; return k });
                  }
                }).catch(e => console.log(e));

                setIsDraftAlready(false);
                if (emailContent) {
                    let msg = emailContent.toString("html");
                    msg = msg.replace("<p>", "");
                    msg = msg.replace("</p>", "");
                    msg = msg.replace("<br>", "");
                    msg = msg.replaceAll("&nbsp;", "");
                    msg = msg
                      .replace("<p>", "")
                      .replace("</p>", "")
                      .replace("<br>", "")
                      .replace("<h1>", "")
                      .replace("</h1>", "")
                      .replace("<h2>", "")
                      .replace("</h2>", "")
                      .replace("<h3>", "")
                      .replace("</h3>", "")
                      .replace("<em>", "")
                      .replace("</em>", "")
                      .replace("<h1></h1>", "")
                      .replace("<h2></h2>", "")
                      .replace("<h3></h3>", "")
                      .replace("<pre><code></code></pre>", "")
                      .replace("<blockquote></blockquote>", "")
                      .replace("<ul>↵ <li></li>↵</ul>", "")
                      .replace("<ol>↵ <li></li>↵</ol>", "");
                    obj.content = emailContent;
                    obj.mode = "draft";
                    if (draftId) {
                      await DeleteDraftMsg(currentAccounts?.accountId, selectedFolder?.folderId, draftId)
                    }
                    obj.subject = composeMailObj?.subject;
                    obj.toAddress = composeMailObj?.to
                      ?.map((e) => e.email)
                      ?.join(",");
                    obj.ccAddress = composeMailObj?.cc
                      ?.map((e) => e.email)
                      ?.join(",");
                    obj.bccAddress = composeMailObj?.bcc
                      ?.map((e) => e.email)
                      ?.join(",");
                    obj.mailFormat = "html";
                    handleSendEmail(obj);
                    if (msg) {
                      setComposeEmailPopUp(false);
                      setContentShowFlag("");
                      setComposeMailObj({
                        from: "",
                        to: [],
                        cc: [],
                        bcc: [],
                        subject: "",
                      });
                    } 
                }
                swal("Email saved to Drafts!", { icon: "success" });
              } else {
                setAttachments([]);
                setShowCC(false);
                setShowBCC(false);
              }
              if (
                contentShowFlag == "replyemail" ||
                contentShowFlag == "replyallemail"
              ) {
                setContentShowFlag("viewemail");
                return;
              }
              setViewEmail(null);
              setContentShowFlag("");
            });
          }} type="button" className="btn btn-sm btn-outline-secondary">
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </Col>}
      </Row>

      <Row sm={12} className="Compose-Email-Header">
        <Col sm={11} className="left" style={{padding:'5px 0px 5px 15px'}}>
          {fromtask?
          <div className='Custome-Inpute-Wrapper'> 
          <Row className='Custome-Row' sm={12}>
           <Col className='Titels' sm={1}> 
             From 
           </Col>
           <Col className='inpute-col' sm={11}>
           <Row sm={10}> 
           <Col sm={10} className='Input-Wrapper'>
             <Select
               wrapperClassName='drpdn'
               className='drpdn'
               style={{minHeight: '33px'}}
               multi={false}
               searchable={false}
               disabled={false}
               onChange={opt=>{ 
                let obj=[{email:opt[0].value?.split(' -')[0],id:0}]
                setComposeMailObj({ ...composeMailObj, from: obj });
               }}
               options={[
                {label:userinfo.email_id==task?.TaskFlowObject?.BotAccountEmail?`${task?.TaskFlowObject?.BotAccountEmail} - Bot`:task?.TaskFlowObject?.BotAccountEmail,
                value:userinfo.email_id==task?.TaskFlowObject?.BotAccountEmail?`${task?.TaskFlowObject?.BotAccountEmail} - Bot`:task?.TaskFlowObject?.BotAccountEmail},
                {label:userinfo.email_id,value:userinfo.email_id}]}
               values={composeMailObj.from?.map(e => ({ label: e.email, value: e.email })) || []}
             />
             </Col>
             </Row>
             </Col> 
           </Row>
         </div>
          :
          <MultiSelectInpute
            lable={"From"}
            isMultiSelect={false}
            disabled={true}
            dropdownDisplayKey={"email"}
            values={allUsers}
            clear={clearFields}
            preInputeValue={(contentShowFlag === "compose" && !fromtask) ? userinfo?.email_id : fromtask?composeMailObj.from?.map(e=>e.email)[0]:composeMailObj.from}
            onChange={() => {}}
            dropdownValueKey={"id"} 
          />  } 
          <MultiSelectInpute
            lable={"To"}
            isMultiSelect={true}
            dropdownDisplayKey={"email"}
            values={allUsers}
            preValues={composeMailObj?.to}
            onChange={(data) => {
              setComposeMailObj({ ...composeMailObj, to: data });
            }}
            dropdownValueKey={"id"}
            task={fromtask}
          />
          {((isReply && contentShowFlag == "replyallemail") || (isForward && contentShowFlag == "forward") ||
                          contentShowFlag == "compose") && (
                          <>
                            <MultiSelectInpute
                              showCC={showCC}
                              lable={"Cc"}
                              isMultiSelect={true}
                              dropdownDisplayKey={"email"}
                              preValues={composeMailObj.cc}
                              onChange={(data) => {
                                setComposeMailObj({ ...composeMailObj, cc: data });
                              }}
                              values={allUsers}
                              dropdownValueKey={"id"}
                              task={fromtask}
                            />
                            <MultiSelectInpute
                              showBCC={showBCC}
                              lable={"Bcc"}
                              isMultiSelect={true}
                              dropdownDisplayKey={"email"}
                              onChange={(data) => {
                                setComposeMailObj({ ...composeMailObj, bcc: data });
                              }}
                              values={allUsers}
                              dropdownValueKey={"id"}
                              task={fromtask}
                            />
                          </>
                        )}
                        {!isReply && (
                         <MultiSelectInpute
                           lable={"Subject"}
                           isMultiSelect={false}
                           disabled={contentShowFlag == "compose" || contentShowFlag == "forward" ? false : true}
                           preInputeValue={composeMailObj.subject}
                           onChange={(data) => {
                             setComposeMailObj({ ...composeMailObj, subject: data });
                           }}
                           // dropdownDisplayKey={"email"}
                           values={allUsers}
                           task={fromtask}
                           // dropdownValueKey={"id"}
                         />
                       )}
        </Col>
        <Col sm={1} className="mb-2 mt-1 right">
          {getCCOptions()}
        </Col>
      </Row>
       {/* {fromtask && emailAttachmentInfo && <PreviewAndDownload attachments={emailAttachmentInfo} getIconByType={getIconByType}/>} */}
      <Row sm={12} style={{ height: contentShowFlag === "replyallemail" ? "72%" : "88%" }} onDrop={e=>{
              let file=e.dataTransfer.files;
              if(file){
                handleFileAttachments(file);
              }
            }}
            onDragOver={e=>e.preventDefault()}>
        {isReply ? (
          <div className="message-content reply-content">
            <p onClick={handleNotificationHyperlink} dangerouslySetInnerHTML={{ __html: "Re : " + viewEmail?.subject }}></p>
            <JoditTextEditor
              id="email"
              signature={signature}
              isSchedule={isSchedule}
              Attachments={attachments}
              emailContent={emailContent}
              preValues={draftEmailContent}
              setIsSchedule={setIsSchedule}
              composeMailObj={composeMailObj}
              isDraftAlready={isDraftAlready}
              setEmailContent={setEmailContent}
              contentShowFlag={contentShowFlag}
              handleUploadFiles={handleUploadFiles}
              composeMailToShow={composeMailToShow}
              // openSchedulePopup={openSchedulePopup}
              // setOpenSchedulePopup={setOpenSchedulePopup}
              // openAttachmentPopUp={openAttachmentPopUp}
              // setOpenAttachmentPopUp={setOpenAttachmentPopUp}
            />
          </div>
        ) : (
          <JoditTextEditor
            id="email"
            signature={signature}
            isSchedule={isSchedule}
            Attachments={attachments}
            emailContent={emailContent}
            preValues={draftEmailContent}
            setIsSchedule={setIsSchedule}
            composeMailObj={composeMailObj}
            isDraftAlready={isDraftAlready}
            contentShowFlag={contentShowFlag}
            setEmailContent={setEmailContent}
            handleUploadFiles={handleUploadFiles}
            composeMailToShow={composeMailToShow}
            // openSchedulePopup={openSchedulePopup}
            // setOpenSchedulePopup={setOpenSchedulePopup}
            // openAttachmentPopUp={openAttachmentPopUp}
            // setOpenAttachmentPopUp={setOpenAttachmentPopUp}
          />
        )}
      </Row>
    </Col>
  );
};

export default ComposeEmail;
